import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect, MDBInput, MDBIcon   } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip     } from 'antd';
import Axios from 'axios'
import SelectSearch from 'react-select-search';
//import Selects from 'react-select';

import Swal from 'sweetalert2'

const { Option } = Select;
function onChange(value) {
  console.log(`selected ${value}`);
}

function onBlur() {
  console.log('blur');
}

function onFocus() {
  console.log('focus');
}

function onSearch(val) {
  console.log('search:', val);
}

export default class Modalarticlefacultyex extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",
   id_send:"",
   filecomment1:null,
   filecomment2:null,
   selectedOption: null,

}

this.handleChange = this.handleChange.bind(this);
this.handleChange2 = this.handleChange2.bind(this);
this.handleChange3 = this.handleChange3.bind(this);
this.handleSubmit = this.handleSubmit.bind(this);
this.getExpert = this.getExpert.bind(this);
this.toggle = this.toggle.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
//  this.props.selectatf();
}


 componentDidMount() {
      const { id_send } = this.props.id_send

      console.log(id_send);
      this.setState({ id_send:this.props.id_send})
      setTimeout(() => {
        //ภายใน
       //  Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpertbn.php')
         Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
        .then(res => {
          console.log(res);
        //  this.setState({ bankname: res.data, loading: false })
          this.setState({ Expert: res.data})
        }) 
      }, 0);

  }

  getExpert() {
    setTimeout(() => {
      //ภายใน
       Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
      // Axios.get('http://localhost/PHPAPI/selectExpertbn.php')
      .then(res => {
        console.log(res);
      //  this.setState({ bankname: res.data, loading: false })
        this.setState({ Expert: res.data})
      }) 
    }, 0);

}


  handleChange(event) { 
  //  console.log(event.target.value)  
     this.setState(
    {idExpert: event.target.value});
  }
  handleChange2(event) {    this.setState({filecomment1: event.target.files[0]});  }
  handleChange3(event) {    this.setState({filecomment2: event.target.files[0]});  }

  handleSubmit(event) {
    // alert('A name was submitted: ' + this.state.value);
   setTimeout(() => {
      event.preventDefault();
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("idExpert", this.state.idExpert);
      datafrm.append("idsend", this.state.id_send);
      datafrm.append("avatar", this.state.filecomment1);
      datafrm.append("avatar2", this.state.filecomment2);
      

    
 Axios.post("https://conference.kpru.ac.th/PHPAPI/insertExpert.php",datafrm)
   .then(res => {
   //  console.log("response: ", res)
     if (res.data.length !== 0) {
     
       console.log(res)
       console.log(res.data.length) 
     
    }else{
     
    }
  })



  
//อัพเดทสถานะ

  Axios.post("https://conference.kpru.ac.th/PHPAPI/updatestapat1.php",datafrm)
    .then(res => {
      console.log("response: ", res)
 
      if (res.data.length !== 0) {
      
        console.log(res)
        console.log(res.data.length)
     }else{
     
     }
   })



  // Axios.post("https://conference.kpru.ac.th/PHPAPI/uploadsentclose.php",datafrm,{
    Axios.post("https://conference.kpru.ac.th/PHPAPI/uploadsentcloseex.php",datafrm,{ 
    headers: {
        'content-type': 'multipart/form-data'
    }
   })
   .then(res => {
   // console.warn(res);
   //  console.log("response: ", res)
     if (res.data.status = 'success999') {
        Swal.fire({
         title: 'เลือกผู้ทรงคุณวุฒิสำเร็จ',
         text: "You won't be able to revert this!",
         icon: 'success',
         showCancelButton: false,
         confirmButtonColor: '#3085d6',
         cancelButtonColor: '#d33',
         confirmButtonText: 'ตกลง'
       }).then((result) => {
         if (result.isConfirmed) {
             this.props.selectatf()
             this.toggle()
         }
       })
       
       }else{
             message.error("อัพโหลไฟล์ไม่สำเร็จ!")
       }

  })

 //this.toggle()

  // window.location.href = '/adminfaculty'

}, 2000);

  //this.props.updateat();
  
  this.getExpert()


  }
    render() {
    //   const options = [];
    //   for (let i = 0; i < 0; i++) {
    //     options.push({
    //       value: this.state.Expert[0].id,
    //       label: this.state.Expert[0].register_nameth
    //     },);
    // }
   // console.log(this.state.idExpert)
      // const options = this.state.Expert.map(Expert =>
      //   [{ value:Expert.id , label:Expert.register_nameth},]
      // );
      const { selectedOption } = this.state;
  
        return (
            <MDBContainer>
            <MDBBtn onClick={this.toggle}>จัดการผู้ทรงคุณวุฒิ</MDBBtn>

            <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
              <MDBModalHeader toggle={this.toggle}>{this.props.namearticla}</MDBModalHeader>
              <MDBModalBody>
              <div>
              {/* <p>เลือกผู้ทรงคุณวุฒิ</p> */}
              {/* <Select
    showSearch
    style={{ width: 400 }}
    placeholder="เลือกผู้ทรงคุณวุฒิ"
    optionFilterProp="children"
    onChange={this.handleChange}
    onFocus={onFocus}
    onBlur={onBlur}
   
  >
                      {this.state.Expert.map((Expert,index )  => 
                          <Option value={Expert.id}>{Expert.register_nameth} {Expert.register_lnameth} </Option>
                          )}
   
  </Select> */}
             
             <div className="mb-2">
             <label><strong>เลือกผู้ทรง</strong></label>
                <select className="browser-default custom-select" onChange={this.handleChange}>
                          <option>------กรุณาเลือกผู้ทรง------</option>
                          {this.state.Expert.map((Expert,index )  => 
                          <option value={Expert.id}>{Expert.register_pname}{Expert.register_nameth} {Expert.register_lnameth}</option>
                          )}
                </select>
                </div>
                <br/>
                {/* <p>อัพโหลดไฟล์บทความ(ปิดชื่อผู้เขียน) .word </p>
                      <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                        success="right"  name="file" value={this.state.value} onChange={this.handleChange2}/>

                <p>อัพโหลดไฟล์บทความ(ปิดชื่อผู้เขียน) .pdf </p>
                      <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                        success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/> */}

                    <div className="mb-2">
                            <label><strong>อัพโหลดไฟล์บทความ <MDBIcon icon="file-word" /> .docx</strong></label>
                                {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                 success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/> */}
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChange2}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/msword,*"
                                        required />
                    </div>
                    <div className="mb-2">
                            <label><strong>อัพโหลดไฟล์บทความ <MDBIcon icon="file-pdf" /> .pdf</strong></label>
                                {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                 success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/> */}
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChange3}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/pdf,*"
                                    />
                     </div>

              </div>
              </MDBModalBody>
              <MDBModalFooter>
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn>
              </MDBModalFooter>
            </MDBModal>
          </MDBContainer>
        )
    }
}
